/** Figma report page frame — 1920×1080 (16:9). */
const FIGMA_PAGE_WIDTH = 1920;
const FIGMA_PAGE_HEIGHT = 1080;

/**
 * Figma px on the 1920px-wide frame → percent of page width (a unitless scaling
 * number). Use directly as `%` for width-relative layout, or feed to
 * `getScalingSize` for sizes (it appends `cqw`/`vw` per `scalingStrategy`).
 */
export const figmaPxToWidthPercent = (px: number) =>
  (px / FIGMA_PAGE_WIDTH) * 100;

/** Figma px on the 1080px-tall frame → percent of page height (see {@link figmaPxToWidthPercent}). */
export const figmaPxToHeightPercent = (px: number) =>
  (px / FIGMA_PAGE_HEIGHT) * 100;

/** 1px border on the 1920px frame — scaling number (feed to `getScalingSize`). */
export const REPORT_BORDER_WIDTH_PERCENT = figmaPxToWidthPercent(1);

/** 2px border on the 1920px frame — scaling number (feed to `getScalingSize`). */
export const REPORT_BORDER_WIDTH_2_PERCENT = figmaPxToWidthPercent(2);

/**
 * Default {@link Report.Page} inset — Figma 118px on the 1920 frame
 * (High-carbon products title/list offset from the page edge).
 */
export const REPORT_PAGE_DEFAULT_PADDING = figmaPxToWidthPercent(118);
